import { render, staticRenderFns } from "./exactSearch.vue?vue&type=template&id=ba12f53e&scoped=true&"
import script from "./exactSearch.vue?vue&type=script&lang=js&"
export * from "./exactSearch.vue?vue&type=script&lang=js&"
import style0 from "./exactSearch.vue?vue&type=style&index=0&id=ba12f53e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12f53e",
  null
  
)

export default component.exports